export default class CandidateTimeEntries {
  constructor({
    startTime,
    endTime,
    mealBreakMinutes,
    firstInteractionDateUtc,
  }) {
    /**
     * @type {string}
     */
    this.startTime = startTime
    /**
     * @type {string?} Nullable to represent incomplete clock-out
     */
    this.endTime = endTime
    /**
     * @type {number?} Nullable to represent incomplete meal submission
     */
    this.mealBreakMinutes = mealBreakMinutes
    /**
     * @type {Date}
     */
    this.firstInteractionDateUtc = firstInteractionDateUtc
  }
}
